import axios from "axios"

const api = "tiendas/geolocalizacion";

const geolocalizacion = {
    leecheros: params => axios.get(`${api}/leecheros`, { params }),
    puntos: params => axios.get(`${api}/puntos`, { params }),
}

export default geolocalizacion